// Enums
export enum TicketStatusEnum {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  RESOLVED = "RESOLVED",
  REOPENED = "REOPENED",
  WAITING_CUSTOMER = "WAITING_CUSTOMER",
  WAITING_SUPPORT = "WAITING_SUPPORT",
}

export enum TicketPriorityEnum {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  NORMAL = "NORMAL",
  HIGH = "HIGH",
  URGENT = "URGENT",
}

export enum MessageSenderTypeEnum {
  CUSTOMER_PERSON = "CUSTOMER_PERSON",
  EMPLOYEE = "EMPLOYEE",
}

export enum TicketSortByEnum {
  LAST_MESSAGE = "last_message",
  UPDATED_AT = "updated_at",
}

export enum SortOrderEnum {
  ASC = "asc",
  DESC = "desc",
}

// Base Interfaces
export interface IProfile {
  id: string;
  kid: string;
  first_name: string;
  last_name: string;
  email?: string;
  gender?: string;
  mobile?: string;
  username?: string;
}

export interface IEmployee {
  id: string;
  profile_id: string;
  kid: string;
  deleted: boolean;
  locked: boolean;
  branch_ids: string[];
  roles: string[];
  capillary_sales_line_ids: string[];
  profile: IProfile;
}

export interface IPerson {
  id: string;
  title: string;
  locked: boolean;
  profile: IProfile;
}

export interface ICustomer {
  id: string;
  title: string;
  code: number;
  type: string;
  category: string;
  capillary_sales_line?: {
    id: string;
    line_number: number;
    title?: string;
  } | null;
}

export interface IAttachment {
  id: string;
  name?: string;
  url: string;
  thumbnail?: string;
}

// Ticket Interfaces
export interface ITicketListItem {
  id: string;
  subject: string;
  status: TicketStatusEnum;
  priority: TicketPriorityEnum;
  created_at: string;
  updated_at: string;
  customer: ICustomer;
  creator_person: {
    id: string;
    profile: IProfile;
  };
  assigned_to: {
    id: string;
    profile: IProfile;
  } | null;
  messages_count: number;
  last_message: {
    id: string;
    sender_type: MessageSenderTypeEnum;
    message: string;
    created_at: string;
    sender_profile: IProfile;
  };
}

export interface ITicketDetail {
  id: string;
  customer_id: string;
  creator_person_id: string;
  subject: string;
  status: TicketStatusEnum;
  priority: TicketPriorityEnum;
  assigned_to_id: string | null;
  closed_at: string | null;
  deleted: boolean;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  customer: ICustomer;
  creator_person: {
    id: string;
    profile: IProfile;
  };
  assigned_to: {
    id: string;
    profile: IProfile;
  } | null;
  _count: {
    messages: number;
  };
  messages_count: number;
  attachments: IAttachment[];
}

export interface ITicketMessage {
  id: string;
  sender_type: MessageSenderTypeEnum;
  message: string;
  created_at: string;
  employee?: IEmployee;
  person?: IPerson;
  sender_profile: IProfile;
  attachments: IAttachment[];
}

// Request/Response Interfaces
export interface ITicketReplyRequest {
  message: string;
  attachment_ids?: string[];
}

export interface ITicketReplyResponse {
  ticket: {
    id: string;
    status: TicketStatusEnum;
  };
  message: ITicketMessage;
}

export interface IAssignTicketRequest {
  employee_id: string;
}

export interface IAssignTicketResponse {
  message: string;
  ticket_id: string;
  assigned_to_id: string;
}

export interface IUpdateTicketStatusRequest {
  status: TicketStatusEnum;
}

export interface IUpdateTicketStatusResponse {
  message: string;
  ticket_id: string;
  status: TicketStatusEnum;
}

// Query Parameters Interface
export interface ITicketQueryParams {
  page?: number;
  "page-size"?: number;
  deleted?: boolean;
  created_at_max?: string;
  created_at_min?: string;
  sort_order?: SortOrderEnum;
  sort_by?: TicketSortByEnum;
  last_sender_type?: MessageSenderTypeEnum;
  search?: string;
  priority?: TicketPriorityEnum;
  status?: TicketStatusEnum;
  assigned_to_id?: string;
  employee_id?: string;
  creator_person_id?: string;
  person_id?: string;
  customer_id?: string;
}
